import { L as a, f as n, _ as e } from "./export-cdcbfb2b.js";
import { w as o, s } from "./string-trim-14e37ad3.js";
var m = a.PROPER, f = n, t = o, i = "​᠎", u = function(r) {
  return f(function() {
    return !!t[r]() || i[r]() !== i || m && t[r].name !== r;
  });
}, c = e, v = s.trim, p = u;
c({ target: "String", proto: !0, forced: p("trim") }, {
  trim: function() {
    return v(this);
  }
});
export {
  u as s
};
